module.exports = __webpack_public_path__ + "themes/fq/font/proximasoft-regular-webfont.woff2";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/font/proximasoft-regular-webfont.woff2
// module id = 97
// module chunks = d-game